let id = 100000;

export function generateId(): string {
	id += 1;
	return id.toString();
}
